<div class="flex flex-col">

  <div *ngIf="!managingOwner" class="flex flex-col md:flex-row gap-2 items-center">
    <span class="font-semibold">Entity</span>
    <span class="font-semibold">Owners</span>

    <div class="flex flex-col md:flex-row gap-4 ml-4 portal-actions">
    <button type="button" *ngIf="(!managingOwner && !isSubunit && isEditable) || isChange"
            mat-button color="primary" (click)="createOwner()">Add an Owner</button>

    <button type="button" *ngIf="!managingOwner && !isSubunit && approved && isEditable && canChange"
      mat-button color="primary" (click)="requestChange(0, sharedService.add)">Add an Owner(Change)</button>

    <button type="button" *ngIf="!managingOwner && !isSubunit && approved && isEditable && canChange"
      mat-button color="primary" (click)="requestChange(0, sharedService.change)">Change Owner</button>

    <button type="button" *ngIf="!managingOwner && !isChange"
      mat-button color="primary" (click)="getOwners(!includeArchived)">{{includeArchived? 'Hide Archived' : 'Show Archived'}}</button>
    </div>
  </div>

  <div class="flex flex-wrap" *ngIf="!managingOwner" [@slideRight]>
    <div class="md:p-2 w-full" *ngFor="let owner of owners">
      <mat-card>
        <mat-card-content>
          <div class="flex flex-col">
            <div class="flex flex-col md:flex-row gap-2 md:items-center" [ngClass]="isSubunit? '' : '-mt-4'">
              <div class="flex flex-col md:flex-row gap-2 font-semibold text-lg">
                <span>{{ owner.firstName }}</span>
              </div>

              <div class="flex flex-col md:flex-row justify-self-end items-center ml-auto portal-actions" *ngIf="!locked || isSubunit">
                <span class="font-semibold" *ngIf="owner.archived">Archived</span>

                <button type="button" mat-button color="primary" *ngIf="(!locked && !isSubunit) || isChange"
                  (click)="selectOwner(owner)">Edit</button>

                  <button *ngIf="!locked && !isSubunit" type="button" mat-button color="warn" (click)="confirmDelete(owner.id)">Delete</button>

                <button *ngIf="!locked && !isSubunit" type="button" mat-icon-button [color]="owner.archived? 'primary' : 'warn'"
                        (click)="archiveOwner(owner, !owner.archived)" [matTooltip]="owner.archived? 'Un-Archive Owner' : 'Archive Owner'"
                        matTooltipShowDelay="500" matTooltipHideDelay="200">
                  <mat-icon [fontIcon]="owner.archived? 'unarchive' : 'archive'"></mat-icon>
                </button>
              </div>

              <div class="flex flex-col md:flex-row justify-self-end items-center ml-auto portal-actions" *ngIf="locked &&!isSubunit">
                <span class="font-semibold" *ngIf="owner.archived">Archived</span>

                <button *ngIf="!owner.archived && approved && isEditable && canChange" type="button" mat-button color="warn"
                  (click)="requestChange(owner.id, sharedService.delete)">Request to Remove</button>
              </div>
            </div>

            <div class="flex flex-col gap-4">
              <div class="flex flex-col md:flex-row gap-4 portal-section-grid">
                <div class="flex flex-col md:w-1/3">
                  <div class="flex flex-row">
                    <span class="md:w-1/3">Phone:</span>
                    <span>{{ owner.phone | mask:'000-000-0000' }}</span>
                  </div>
                  <div class="flex flex-row">
                    <span class="md:w-1/3">Fax:</span>
                    <span>{{ owner.fax | mask:'000-000-0000' }}</span>
                  </div>
                </div>

                <div class="flex flex-col md:w-1/3">
                  <div class="flex flex-row">
                    <span class="md:w-1/2">Tax ID:</span>
                    <span>{{ owner.taxId }}</span>
                  </div>
                  <div class="flex flex-row">
                    <span class="md:w-1/2">Client Contact:</span>
                    <span>{{ owner.contactWithClient? 'Yes' : 'No' }}</span>
                  </div>
                </div>

                <div class="flex flex-col" *ngIf="owner.contactWithClient">
                  <mat-checkbox class="-mt-3" [(ngModel)]="owner.backgroundCheckCompleted" labelPosition="before" (change)="updateOwnerBackgroundCheck(owner)">
                    <span class="font-semibold">BG Check Complete</span>
                  </mat-checkbox>
                  <mat-form-field>
                    <input placeholder="Background Check Date"
                           [(ngModel)]="ownerBackgroundCheckDates[owner.id]"
                           matInput [matDatepicker]="backgroundCheckDate"
                           [max]="sharedService.today"
                           (dateChange)="updateOwnerBackgroundCheck(owner)" />
                    <mat-datepicker-toggle matSuffix [for]="backgroundCheckDate"></mat-datepicker-toggle>
                    <mat-datepicker #backgroundCheckDate>
                      <mat-datepicker-actions>
                        <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                        <button mat-button matDatepickerCancel>Cancel</button>
                      </mat-datepicker-actions>
                    </mat-datepicker>
                  </mat-form-field>
                </div>
              </div>

              <div class="flex flex-col gap-4">
                <address [entityId]="owner.id"
                         [entityType]="sharedService.entityOwner"
                         [isEditable]="isEditable"
                         [statuses]="statuses"
                         [isChange]="isChange"></address>

                <document *ngIf="owner.contactWithClient"
                          [entityId]="owner.id"
                          [entityType]="sharedService.entityOwner"
                          [editable]="false"></document>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <div class="flex flex-col" *ngIf="managingOwner" [@slideRight]>
    <form [formGroup]="ownerForm">
      <div class="flex flex-col">
        <div class="flex flex-col md:flex-row gap-4 items-center">
          <div>
            <div *ngIf="managingOwner && owner.id === 0" class="owner-edit-heading font-semibold">Add Owner
            </div>
            <div *ngIf="managingOwner && owner.id > 0" class="owner-edit-heading font-semibold">Update Owner
            </div>
          </div>
          <div class="gap-2 flex justify-self-end items-center portal-actions">
            <button type="button" *ngIf="managingOwner && ownerForm.valid && (!locked || isChange)"
                    mat-button color="primary" (click)="saveOwner()">Save</button>
            <button type="button" *ngIf="managingOwner && !locked"
                    mat-button color="warn" (click)="confirmDelete(owner.id)">Delete</button>
            <button type="button" *ngIf="managingOwner"
                    mat-button color="warn" (click)="toggleOwnerForm(false)">Close</button>
          </div>
        </div>

        <div class="flex flex-col pt-4">
          <div class="owner-edit-details">
            <div class="owner-edit-fields">
              <mat-form-field class="owner-name-field">
                <mat-label>Owner Name</mat-label>
                <input matInput formControlName="firstName">
                <mat-error *ngIf="ownerForm.get('firstName')?.hasError('required')">
                  An owner name is required
                </mat-error>
              </mat-form-field>

              <mat-form-field>
                <mat-label>Phone</mat-label>
                <input matInput formControlName="phone" mask="000-000-0000">
                <mat-error *ngIf="ownerForm.get('phone')?.hasError('required')">
                  A phone number is required
                </mat-error>
                <mat-error *ngIf="ownerForm.get('phone')?.hasError('pattern')">
                  Phone should match format: 000-000-0000
                </mat-error>
              </mat-form-field>

              <mat-form-field>
                <mat-label>Fax</mat-label>
                <input matInput formControlName="fax" mask="000-000-0000">
                <mat-error *ngIf="ownerForm.get('fax')?.hasError('pattern')">
                  Fax should match format: 000-000-0000
                </mat-error>
              </mat-form-field>

              <mat-form-field>
                <mat-label>Tax ID</mat-label>
                <input matInput formControlName="taxId">
                <mat-error *ngIf="ownerForm.get('taxId')?.hasError('required')">
                  Tax ID is required
                </mat-error>
              </mat-form-field>
            </div>

            <div class="flex flex-col" *ngIf="entityType !== sharedService.hospitalLicense">
              <div class="flex flex-col gap-2">
                <label id="owner-client-contact">
                  Does the owner have direct contact with any client as defined in OAR 333-536-0093?
                  (If yes, attach 'Background Check Request'.)
                </label>
                <mat-radio-group aria-labelledby="owner-client-contact" formControlName="contactWithClient">
                  <mat-radio-button [value]="true">
                    Yes
                  </mat-radio-button>
                  <mat-radio-button [value]="false">
                    No
                  </mat-radio-button>
                </mat-radio-group>
                <span *ngIf="ownerForm.get('contactWithClient')?.value"
                      class="text-blue-600 cursor-pointer"
                      [@slideRight]
                      (click)="downloadReferenceDocument(sharedService.emptyBackgroundCheck)">
                  Download Background Check Request Form
                </span>
              </div>
            </div>

            <div class="owner-background-completion" *ngIf="showBackgroundCheck">
              <mat-checkbox formControlName="backgroundCheckCompleted" labelPosition="before">
                <span class="font-semibold">BG Check Complete</span>
              </mat-checkbox>
              <mat-form-field>
                <input placeholder="Background Check Date" formControlName="backgroundCheckDate" matInput [matDatepicker]="backgroundCheckDate"
                  [max]="sharedService.today" />
                <mat-datepicker-toggle matSuffix [for]="backgroundCheckDate"></mat-datepicker-toggle>
                <mat-datepicker #backgroundCheckDate>
                  <mat-datepicker-actions>
                    <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                    <button mat-button matDatepickerCancel>Cancel</button>
                  </mat-datepicker-actions>
                </mat-datepicker>
              </mat-form-field>
            </div>
          </div>

          <div>
            <address [entityId]="owner.id"
                     [entityType]="sharedService.entityOwner"
                     [limitEntries]="true"
                     [statuses]="statuses"
                     [isChange]="isChange"
                     (reportOutOfState)="updateOutOfState($event)"></address>
            <div class="flex flex-col gap-4 portal-actions" *ngIf="isOutOfState && entityType !== sharedService.hospitalLicense" [@slideRight]>
              <span class="font-semibold">Owners who reside outside of Oregon must have fingerprints taken.</span>
              <button type="button" class="portal-text-action" (click)="downloadReferenceDocument(sharedService.fingerprints)">
                Download Fingerprint Instructions
              </button>
            </div>
          </div>
        </div>
        <document *ngIf="ownerForm.get('contactWithClient')?.value || isChange"
                  [@slideRight]
                  [entityId]="owner.id"
                  [entityType]="sharedService.entityOwner"
                  [statuses]="statuses"
                  [types]="entityOwnerTypes"></document>
      </div>
    </form>
  </div>
